module.exports = __webpack_public_path__ + "img/iconSubscription.32ff2a25.png";